import { render, staticRenderFns } from "./DespatchManage.vue?vue&type=template&id=c52a4306&scoped=true&"
import script from "./DespatchManage.vue?vue&type=script&lang=js&"
export * from "./DespatchManage.vue?vue&type=script&lang=js&"
import style0 from "./DespatchManage.vue?vue&type=style&index=0&id=c52a4306&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52a4306",
  null
  
)

export default component.exports